export enum FinancialDetailQueryKeysEnum {
  FINANCIAL_DETAIL_STATE = 'coparticipationReportRequestState',
  INVOICE_STATE = 'invoiceState',
  DISCOUNT_LETTERS_STATE = 'discountLettersState',
}
